export const dateObj = new Date();
export const currentDay = dateObj.getDay();
export const currentDate = dateObj.getDate();
export const currentMonth = dateObj.getMonth();
export const currentYear = dateObj.getFullYear();

export const SQL_DAYS = [1, 2, 3, 4, 5, 6, 7] as const;

type SqlDayStr = {
  [dayNumKey: number]: {
    short: string;
    full: string;
  };
};

export const SQL_DAY_STR: SqlDayStr = Object.freeze({
  0: { short: 'None', full: 'One-off', dayInt: 0 },
  1: { short: 'Sun', full: 'Sunday', dayInt: 1 },
  2: { short: 'Mon', full: 'Monday', dayInt: 2 },
  3: { short: 'Tue', full: 'Tuesday', dayInt: 3 },
  4: { short: 'Wed', full: 'Wednesday', dayInt: 4 },
  5: { short: 'Thu', full: 'Thursday', dayInt: 5 },
  6: { short: 'Fri', full: 'Friday', dayInt: 6 },
  7: { short: 'Sat', full: 'Saturday', dayInt: 7 },
});
